/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdPickerItemProps } from './type';
const props: TdPickerItemProps = {
  /** 格式化标签 */
  format: {
    type: null,
  },
  /** 数据源 */
  options: {
    type: Array,
    value: [],
  },
};

export default props;
